import { render, staticRenderFns } from "./CampaignsListHeader.vue?vue&type=template&id=08d49424&lang=pug"
import script from "./CampaignsListHeader.vue?vue&type=script&lang=js"
export * from "./CampaignsListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports